import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';
import { logout } from '../../utils/util-func';

export const onResponse = (res: AxiosResponse) => {
  const { method, url } = res.config;
  return res;
};

let isAlertShown = false;

// 서버 에러 연속 실패 카운터
let serverErrorCount = 0;
const SERVER_ERROR_THRESHOLD = 3;
const SERVER_ERROR_RESET_MS = 10000; // 10초 내 연속 실패 시 공사중 판정
let serverErrorTimer: ReturnType<typeof setTimeout> | null = null;

/** 테스트용: serverErrorCount 리셋 (dev 전용) */
export const __resetServerErrorCount = () => {
  serverErrorCount = 0;
  if (serverErrorTimer) {
    clearTimeout(serverErrorTimer);
    serverErrorTimer = null;
  }
};

const trackServerError = (): boolean => {
  serverErrorCount++;

  if (serverErrorTimer) clearTimeout(serverErrorTimer);
  serverErrorTimer = setTimeout(() => {
    serverErrorCount = 0;
    serverErrorTimer = null;
  }, SERVER_ERROR_RESET_MS);

  return serverErrorCount >= SERVER_ERROR_THRESHOLD;
};

// 서버 에러 피드백 (threshold 미달 시 모달로 안내)
let isServerErrorFeedbackShown = false;
const showServerErrorFeedback = () => {
  if (isServerErrorFeedbackShown) return;
  isServerErrorFeedbackShown = true;
  setTimeout(() => {
    isServerErrorFeedbackShown = false;
  }, 3000);

  const { store } = require('../../../store');
  const { openAlert } = require('../../../store/features/modalSlice');
  store.dispatch(
    openAlert({
      message:
        '서버가 일시적으로 불안정합니다.\n잠시 후 다시 시도해 주세요.',
    })
  );
};

export const onResError = (error: AxiosError | Error) => {
  if (axios.isAxiosError(error)) {
    const config = error.config as any;
    const { method, url } = config as InternalAxiosRequestConfig;

    // retry 체인에서 이미 처리된 에러는 중복 처리하지 않음
    // (instance(config) 재시도 시 onResError가 여러 번 호출되는 것 방지)
    if (config?.__errorHandled) return Promise.reject(error);
    config.__errorHandled = true;

    // 서버 완전 다운 (Network Error, timeout 등)
    if (!error.response) {
      if (trackServerError() && window.location.pathname !== '/error') {
        window.location.href = '/error';
        return new Promise(() => {});
      }
      showServerErrorFeedback();
      return Promise.reject(error);
    }

    const { statusCode, message } = error.response.data;

    // 500번대 서버 에러
    if (statusCode >= 500) {
      if (trackServerError() && window.location.pathname !== '/error') {
        window.location.href = '/error';
        return new Promise(() => {});
      }
      showServerErrorFeedback();
      return Promise.reject(error);
    }

    const expectedUrl = [
      '/v1/auth/sign-in',
      '/v1/sms/with-name',
      '/v1/auth/user-authorization?check=true',
    ];

    // 반복 실패시 한번만 처리를 위한 코드
    if (isAlertShown) return;
    isAlertShown = true;
    setTimeout(() => {
      isAlertShown = false;
    }, 1000);

    if (expectedUrl.includes(url)) return Promise.reject(error);

    switch (statusCode) {
      case 401:
        alert('로그인이 필요합니다.');
        logout();
        if (!localStorage.getItem('redirect')) {
          if (window.location.href.split('/').pop() !== 'signin')
            localStorage.setItem('redirect', window.location.href);
        }
        window.location.href = '/signin';
        return error.response;

      case 403:
        alert('접근 권한이 없습니다.');
        window.location.href = '/';
        return error.response;

      default:
        return Promise.reject(error);
    }
  } else {
    console.log(`🚨 [API] | Error ${error.message}`);
  }

  return Promise.reject(error);
};
